/** @format */

import React, {
  ReactElement,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { useAppSelector } from "../../app/hooks";
import { isOneOfTheseFlagsTrue } from "./featureFlagSlice";

/**
 * The <FeatureFlag/> component is a simple wrapper for any content. It controls whether the content
 * is displayed or not based on whether any of the flags specified in the flag prop are in the Redux
 * state or not. If not, it will show the fallback content if set or null.
 *
 * e.g. <FeatureFlag flag={['dev','preview']} fallback={<>Fallback content</>}> Some content </FeatureFlag>
 * This will show "Some content" if either the dev or preview flag is present, otherwise it will show
 * "Fallback content".
 * The consoleMsg prop can be used to output a reason for the feature being disabled
 */
export interface FeatureFlagProps {
  flag: string | string[];
  fallback?: ReactElement;
  consoleMsg?: string;
}
const FeatureFlag: React.FC<PropsWithChildren<FeatureFlagProps>> = ({
  children,
  flag: flagName,
  fallback,
  consoleMsg,
}) => {
  const [flags] = useState<string[]>(
    !Array.isArray(flagName) ? [flagName] : flagName,
  );
  const isFlagActive = useAppSelector(isOneOfTheseFlagsTrue(flags));

  useEffect(() => {
    if (!isFlagActive) {
      consoleMsg && console.log(consoleMsg);
      return;
    }
    //console.log(`FLAGS ON: ${flags.join(', ')}`)
  }, [isFlagActive, flags, consoleMsg]);

  return isFlagActive ? <>{children}</> : fallback || null;
};

export default FeatureFlag;
